import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_ContractListRecent = _resolveComponent("ContractListRecent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: _normalizeClass([{
        hide: !_ctx.refreshAwaitingList.size,
      }, "icon is-small is-default is-pulled-right is-rounded refresh"])
    }, [
      _createVNode(_component_fa_icon, {
        class: _normalizeClass({ refreshing: !!_ctx.refreshAwaitingList.size }),
        icon: "sync"
      }, null, 8, ["class"])
    ], 2),
    _createVNode(_component_ContractListRecent, {
      account: _ctx.account,
      refreshToggle: _ctx.subRefreshToggle,
      onTriggerContractRefresh: _ctx.trigger
    }, null, 8, ["account", "refreshToggle", "onTriggerContractRefresh"])
  ]))
}